import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import OutsideClickHandler from 'ViatoUi/Shared/Utilities/OutsideClickHandler';

import styles from './Textarea.module.scss';

const Textarea = ({ label, placeholder, value, onChange }) => {
	const [focused, setFocused] = useState(String(value).length > 0);

	const textareaRef = useRef(null);

	useEffect(() => {
		// Workaround for ChromE autofill
		// on autofill a css animation is fired (see css file). With this we can
		// check if the user is using autofill and if so set the focused state to true.
		// ... someone please kill me
		textareaRef.current.addEventListener('animationstart', e => {
			if (e.animationName === 'autofill') {
				setFocused(true);
			}
		});
	}, [value]);

	return (
		<OutsideClickHandler callback={() => setFocused(String(value).length > 0)}>
			<div className={styles.textarea} data-focused={focused}>
				<div className={styles.label}>{label}</div>
				<textarea
					ref={textareaRef}
					id='text'
					name='text'
					placeholder={placeholder}
					value={value}
					onBlur={e => {
						setFocused(e.target.value !== '');
						onChange(e.target.value);
					}}
					onChange={e => {
						setFocused(e.target.value !== '');
						onChange(e.target.value);
					}}
					onFocus={() => {
						setFocused(true);
					}}
				>
					{value}
				</textarea>
			</div>
		</OutsideClickHandler>
	);
};

Textarea.propTypes = {
	label: PropTypes.string,
	placeholder: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func
};

Textarea.defaultProps = {
	label: null,
	placeholder: null,
	value: '',
	onChange: () => {}
};

export default Textarea;
